import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import DashboardApp from './dashboard/DashboardApp';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { DeploymentCapabilitiesProvider } from './context/DeploymentCapabilitiesContext';



const root = ReactDOM.createRoot(document.getElementById('root'));
const isDashboardBuild = process.env.REACT_APP_BUILD_TARGET === 'dashboard';

if (isDashboardBuild) {
  root.render(<DashboardApp />);
} else {
  root.render(
    // <React.StrictMode>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <DeploymentCapabilitiesProvider>
          <App />
        </DeploymentCapabilitiesProvider>
      </BrowserRouter>
    // </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
